import { render, staticRenderFns } from "./ElementBadge.vue?vue&type=template&id=c0ac797e&scoped=true"
import script from "./ElementBadge.vue?vue&type=script&lang=js"
export * from "./ElementBadge.vue?vue&type=script&lang=js"
import style0 from "./ElementBadge.vue?vue&type=style&index=0&id=c0ac797e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ac797e",
  null
  
)

export default component.exports